import { PropertyBookletBuildingType } from "@/views/property/property-booklet/property-booklet.component";
import { Injectable } from "@angular/core";
import { PropertyBookletBuildingDocumentType, PropertyBookletBuildingStage } from "@eemo/api-client";

@Injectable()
export class PropertyBookletBuildingService {

  public requiredDocByType: Map<PropertyBookletBuildingType, PropertyBookletBuildingDocumentType[]> = new Map([
    [PropertyBookletBuildingType.housing, [PropertyBookletBuildingDocumentType.SECTIONS]],
    [PropertyBookletBuildingType.surface, [PropertyBookletBuildingDocumentType.PLANS]],
    [PropertyBookletBuildingType.waterNetwork, [
                                                      PropertyBookletBuildingDocumentType.PLANS, 
                                                      PropertyBookletBuildingDocumentType.DIAGRAMS, 
                                                      PropertyBookletBuildingDocumentType.DESCRIPTIVE
                                                    ]],
    [PropertyBookletBuildingType.electricityNetwork, [
                                                      PropertyBookletBuildingDocumentType.PLANS, 
                                                      PropertyBookletBuildingDocumentType.DIAGRAMS, 
                                                      PropertyBookletBuildingDocumentType.DESCRIPTIVE
                                                    ]],

    [PropertyBookletBuildingType.gasNetwork, [
                                                      PropertyBookletBuildingDocumentType.PLANS, 
                                                      PropertyBookletBuildingDocumentType.DIAGRAMS, 
                                                      PropertyBookletBuildingDocumentType.DESCRIPTIVE
                                                    ]],
    [PropertyBookletBuildingType.ventilationNetwork, [
                                                      PropertyBookletBuildingDocumentType.PLANS, 
                                                      PropertyBookletBuildingDocumentType.DIAGRAMS, 
                                                      PropertyBookletBuildingDocumentType.DESCRIPTIVE
                                                    ]],

  ])

  public static getTitle(buildingComponent: PropertyBookletBuildingType): string {
    let title = '';
    switch (buildingComponent) {
      case PropertyBookletBuildingType.electricityNetwork:
        title = 'Réseaux d’électricité';
        break;
      case PropertyBookletBuildingType.gasNetwork:
        title = 'Réseaux de gaz';
        break;
      case PropertyBookletBuildingType.housing:
        title = 'Logement';
        break;
      case PropertyBookletBuildingType.surface:
        title = 'Surface';
        break;
      case PropertyBookletBuildingType.ventilationNetwork:
        title = 'Réseaux d’aération';
        break;
      case PropertyBookletBuildingType.waterNetwork:
        title = 'Réseaux d’eau';
        break;    
      default:
        console.error('PropertyBookletBuildingCardComponent.setTitle(): Undefined title')
        break;
    }
    return title;
  }

  public static getSummary(buildingComponent: PropertyBookletBuildingType): string {
    let summary = '';
    const summaryNetworkTemplate = 'Ajoutez les plans, schémas et descriptifs des réseaux';
    switch (buildingComponent) {
      case PropertyBookletBuildingType.electricityNetwork:
        summary = `${summaryNetworkTemplate} d’électricité`;
        break;
      case PropertyBookletBuildingType.gasNetwork:
        summary = `${summaryNetworkTemplate} de gaz`;
        break;
      case PropertyBookletBuildingType.housing:
        summary = 'Ajoutez les plans de coupes du logement';
        break;
      case PropertyBookletBuildingType.surface:
        summary = 'Ajoutez les plans de surface';
        break;
      case PropertyBookletBuildingType.ventilationNetwork:
        summary = `${summaryNetworkTemplate} d’aération`;
        break;
      case PropertyBookletBuildingType.waterNetwork:
        summary = `${summaryNetworkTemplate} d’eau`;
        break;
      default:
        console.error('PropertyBookletBuildingCardComponent.getSummary(): Undefined summary');
        break;
    }
    return summary;
  }

  public static getBuildingDocTypeTranslate(docType: PropertyBookletBuildingDocumentType) {
    let type = '';
    switch (docType) {
      case PropertyBookletBuildingDocumentType.PLANS:
        type = 'Plans';
        break;
      case PropertyBookletBuildingDocumentType.SECTIONS:
        type = 'Coupes';
        break;
      case PropertyBookletBuildingDocumentType.DIAGRAMS:
        type = 'Schémas';
        break;
      case PropertyBookletBuildingDocumentType.DESCRIPTIVE:
        type = 'Descriptifs';
        break;
      default:
        console.error('getBuildingDocTypeTranslate(): Undefined type')
        break;
    }
    return type;
  }

  public static getBookletBuildingStageTranslate(stage: PropertyBookletBuildingStage) {
    let translation = '';
    switch (stage) {
      case PropertyBookletBuildingStage.DESIGN:
        translation = 'Conception';
        break;
      case PropertyBookletBuildingStage.EXECUTION:
        translation = 'Exécution';
        break;
      default:
        console.error('getBookletBuildingStageTranslate(): Undefined type')
        break;
    }
    return translation;
  }
}